import { IQueryAttributeGroup } from "./query-attribute-group.interface";
import { QueryAttributeDto } from "./query-attribute.dto";

export class QueryAttributeGroupDto implements IQueryAttributeGroup {
  //
  [operator: string]:
    | (QueryAttributeDto | QueryAttributeGroupDto)[]
    | undefined;
}
